module.exports = __webpack_public_path__ + "img/logo.3e9afa2c.png";